import { useAtom } from "jotai";
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { activeChildDetail } from "../../../../AtomStore/store";
import { useRequestProcessor } from "../../../../requestProcessor";
import { sendFeeCertificate } from "../../../../QueryFunctions/queryfunction";
import SpinnerLoading from "../../../../Components/utils/SpinnerLoading";

const ShareFeeCertificate1 = () => {
  const location = useLocation();
  const certificateUrl = location?.state?.url;

  const [activeChild] = useAtom(activeChildDetail);

  const navigate = useNavigate();

  const { useMutationWrapper } = useRequestProcessor();

  useEffect(() => {
    console.log(
      "[Share Certificate] Loading share certificate screen for  for child:",
      activeChild?.id
    );
  }, [activeChild]);

  const Sharecertificate = useMutationWrapper(
    "Sharecertificate",
    () => {
      console.log(
        "[Share Certificate] Calling API: /financials/sendFeeCertificate ",
        {
          certificateUrl: certificateUrl,
          child_id: activeChild?.id,
        }
      );
      return sendFeeCertificate(certificateUrl, navigate);
    },
    {
      onSuccess: (data) => {
        console.log("[Share Certificate] Send Certificate response:", data);
      },
    }
  );
  return (
    <div className="bg-header h-[85vh]">
      {Sharecertificate.isLoading ? <SpinnerLoading /> : ""}

      <ul className="sm:mx-3 md:mx-25 lg:mx-50   py-5 ">
        <li
          onClick={() => {
            Sharecertificate.mutate();
          }}
          className=" flex  bg-white items-center  text-lg  text-center rounded-full shadow-md py-3 border-2 px-10 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="red"
            stroke="black"
            id="Layer_1"
            data-name="Layer 1"
            viewBox="0 0 24 24"
            className="size-10 mr-4"
          >
            <path d="M9.878,17.122c1.134,1.133,3.11,1.133,4.243,0l6.879-6.879V4c0-2.206-1.794-4-4-4H7C4.794,0,3,1.794,3,4v6.243l6.878,6.879Zm-1.878-13.122h8c1.308,.006,1.307,1.995,0,2H8c-1.308-.006-1.307-1.994,0-2Zm0,4h6c1.308,.006,1.307,1.995,0,2h-6c-1.308-.006-1.307-1.994,0-2Zm15.5,2.57c.316,.665,.5,1.392,.5,2.137v6.292c0,2.757-2.243,5-5,5H5c-2.757,0-5-2.243-5-5v-6.292c0-.746,.184-1.472,.5-2.137l7.965,7.966c1.862,1.939,5.21,1.94,7.071,0l7.965-7.966Z" />
          </svg>
          Send To Mail
        </li>
        <li className=" flex  items-center bg-white text-lg  text-center rounded-full shadow-md py-3 border-2 px-10 mt-3">
          <svg
            id="Layer_1"
            viewBox="0 0 24 24"
            fill="yellow"
            stroke="black"
            className="size-10 mr-4"
            xmlns="http://www.w3.org/2000/svg"
            data-name="Layer 1"
          >
            <path d="m20 20.444v3.556l-2-2-2 2v-3.556a4 4 0 1 1 4 0zm-6 1.019v.537h-11v-19a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v8.809a5.993 5.993 0 0 0 -7 9.654zm-7-15.463h10v-2h-10zm0 4h10v-2h-10zm0 4h5v-2h-5z" />
          </svg>
          <a href={certificateUrl} target="_blank" rel="noreferrer">
            View Certificate
          </a>
        </li>
        <li
          onClick={() => {
            navigate("/feeCertificate");
          }}
          className=" flex  items-center  bg-white text-lg  text-center rounded-full shadow-md py-3 border-2 px-10 mt-3 cursor-pointer"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            id="Layer_1"
            data-name="Layer 1"
            viewBox="0 0 24 24"
            className="size-10 mr-4"
          >
            <path d="m21,0H3C1.346,0,0,1.346,0,3v21h24V3c0-1.654-1.346-3-3-3Zm-9,20c-3.022,0-5.64-1.697-7-4.177v3.177h-2v-4c0-1.103.897-2,2-2h4v2h-2.169c1.039,1.787,2.957,3,5.169,3,2.967,0,5.431-2.167,5.91-5h2.021c-.495,3.94-3.859,7-7.931,7Zm9-11c0,1.103-.897,2-2,2h-4v-2h2.185c-1.037-1.791-2.97-3-5.185-3-2.967,0-5.431,2.167-5.91,5h-2.021c.495-3.94,3.859-7,7.931-7,3.015,0,5.639,1.679,7,4.15v-3.15h2v4Z" />
          </svg>
          Regenerate Certificate
        </li>
      </ul>
    </div>
  );
};

export default ShareFeeCertificate1;
